import * as React from 'react';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps } from 'theme/jss-types';
import { formFields } from 'components/create-consignment/create-modal.constants';
import {
    Col,
    Form,
    FormInstance,
    Input,
} from 'antd';
import { formRules } from 'library/constants';
import { useTranslation } from 'react-i18next';

const styles = () => ({
    title: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
    },
    referenceItemEway: {
        display: 'flex',
        flexDirection: 'column',
    },
    referenceTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
    },
});

interface IProps extends StylesProps<ReturnType<typeof styles>>, ReturnType<typeof mapStateToProps> {
    form: FormInstance;
    params: any;
}

const EwayBillNumberField = (props: IProps) => {
    const { t, i18n } = useTranslation();
    const {
        classes,
        showEwayBill,
        form,
        params,
        customerPortalOrderCreationConfig,
    } = props;
    const {
        ConsignmentCategory,
        DeclaredValue,
        EwayBillType,
        EwayBillNumber,
    } = formFields;

    const { getValidationRules, disabledFields = {} } = params;
    const consignmentCategory = Form.useWatch(ConsignmentCategory.key, form);
    const declaredValueFieldData = Form.useWatch(DeclaredValue.key, form);
    const ewayBillType = Form.useWatch(['ewayBill', EwayBillType.key], form);
    const checkDeclaredValueIsInt = (declaredValueFieldData && !Number.isNaN(declaredValueFieldData));
    const declaredValue = checkDeclaredValueIsInt ? Number(declaredValueFieldData) : 0;

    const showField = declaredValue > 50000 && showEwayBill && consignmentCategory !== 'international';

    if (!customerPortalOrderCreationConfig?.is_enabled) {
        if (!showField) return null;
        if (ewayBillType !== 'ewaybill_number') return null;
    }

    const formRuleRequired = {
        ...formRules.required,
        message: i18n.exists('required') ? t('required') : 'Required',
    };

    return (
        <Col span={24} xs={24} sm={24} md={12}>
            <div className={classes.referenceItemEway}>
                <div
                    className={classes.title}
                >
                    {t(EwayBillNumber.key)}
                </div>
                <Form.Item
                    name={['ewayBill', EwayBillNumber.key]}
                    className={classes.referenceTitle}
                    initialValue={EwayBillNumber.defaultValue}
                    valuePropName={EwayBillNumber.valuePropName}
                    rules={ewayBillType === 'ewaybill_number'
                        ? [formRuleRequired, ...getValidationRules(EwayBillNumber)] : getValidationRules(EwayBillNumber)}
                >
                    <Input
                        placeholder={EwayBillNumber.placeholder}
                        disabled={!!disabledFields[EwayBillNumber.key]}
                    />
                </Form.Item>
            </div>
        </Col>
    );
};

const mapStateToProps = (state: any) => {
    const { master } = state;
    const { config } = master;
    return {
        showEwayBill: config?.customer_portal_consignment_config?.show_eway_bill_details || false,
        customerPortalOrderCreationConfig: config?.customer_portal_order_creation_config || {},
    };
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
};

export default GenericHoc(hocConfig)(EwayBillNumberField);
